import React from "react";
import { 
    PageWrapper,
    ContentWrapper,
    LogoContainer,
    CompanyName,
    Description,
    LaunchDate,
 } from "./elements";

function ComingSoonPage() {
  return (
    <PageWrapper>
      <ContentWrapper>
        <LogoContainer>
        </LogoContainer>
        <CompanyName>Brilliant Insight</CompanyName>
        <Description>Understand Your Clients</Description>
        <LaunchDate>Coming Soon 2024</LaunchDate>
      </ContentWrapper>
    </PageWrapper>
  );
}

export default ComingSoonPage;